export default {"src":"https://js-static.iimjobs.com/production/8.5.0/_next/static/media/ceo.740ed2f7.svg","height":67,"width":80,"blurWidth":0,"blurHeight":0};